<section class="page">
  @if (toast()) {
    <div class="toast">
      <mat-icon>notifications_active</mat-icon>
      <div>
        <strong>{{ toast()!.title }}</strong>
        <p>{{ toast()!.message }}</p>
      </div>
      @if (toast()!.actionUrl) {
        <a mat-button [routerLink]="toast()!.actionUrl">Open</a>
      }
      <button mat-icon-button type="button" (click)="toast.set(null)"><mat-icon>close</mat-icon></button>
    </div>
  }

  <header class="page-header">
    <div>
      <h1>Notifications</h1>
      <p>Your recent alerts and activity updates.</p>
    </div>
    <button mat-stroked-button type="button" (click)="markAllRead()">Mark all read</button>
  </header>

  @if (error()) { <div class="error">{{ error() }}</div> }
  @if (loading()) { <div class="loading"><mat-spinner diameter="36"></mat-spinner></div> }

  <ul class="notification-list">
    @for (n of items(); track n.id) {
      <li class="notification-item" [class.unread]="isUnread(n)" (click)="markRead(n)">
        <div class="icon-wrap"><mat-icon>{{ isUnread(n) ? 'mark_email_unread' : 'drafts' }}</mat-icon></div>
        <div class="body">
          <strong>{{ n.title }}</strong>
          <p>{{ n.message }}</p>
          <span class="time">{{ timeLabel(n.createdAt) }}</span>
        </div>
        @if (n.actionUrl) {
          <a mat-button [routerLink]="n.actionUrl" (click)="$event.stopPropagation()">Open</a>
        }
      </li>
    } @empty {
      @if (!loading()) {
        <li class="empty muted">No notifications yet.</li>
      }
    }
  </ul>
</section>
